export default __webpack_public_path__ + "static/media/roundAdd.6bf67d3b.svg";